<template>
  <UModal
    :title="title"
    :description="description"
    :ui="{
      header: 'p-0!',
      title: 'text-size-h3! font-semibold text-modal-title mb-2.5',
      description:
        'text-content-default-secondary! font-lato! text-sm! max-w-7/9',
      content: 'w-112.5! p-8',
      close: 'ring ring-neutral-border-default! top-8',
    }"
  />
</template>

<script setup lang="ts">
defineOptions({
  name: 'SuccessModal',
})

withDefaults(
  defineProps<{
    title?: string
    description?: string
  }>(),
  {
    title: 'Спасибо, ваша заявка отправлена',
  },
)
</script>
